import { useCallback, useState } from "react";
import { useEffect } from "react";

import api from "../../../../api/api";

const useGetCards = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCardsDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/api/firmsetting-page/get-cards/");
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchCardsDetails();
  }, [fetchCardsDetails]);

  return { data, loading, error, refetch: fetchCardsDetails };
};

export default useGetCards;

const useGetAddCardsDetails = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCardsDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get("/api/firmsetting-page/add-card/");
      setData(response.data);
    } catch (error) {
      setError(error);
    }
  }, []);

  useEffect(() => {
    fetchCardsDetails();
  }, [fetchCardsDetails]);

  return { data, loading, error, refetch: fetchCardsDetails };
};

export { useGetAddCardsDetails };

const useAddCard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const saveCard = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("/api/firmsetting-page/add-card/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { saveCard, loading, error, success };
};

export { useAddCard };

const useEditCard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const editCard = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("/api/firmsetting-page/edit-card/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { editCard, loading, error, success };
};

export { useEditCard };

const useDeleteCard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const deleteCard = async (cardId) => {
    setLoading(true);
    try {
      const response = await api.get("/api/firmsetting-page/delete-card/", {
        params: { card_id: cardId },
      });
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { deleteCard, loading, error, success };
};

export { useDeleteCard };

const useChangeCardStatus = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const changeStatus = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("/api/firmsetting-page/change-card-status/", payload);
      setSuccess(response.data);
    } catch (error) {
      setError(error);
    }
  };

  return { changeStatus, loading, error, success };
};

export { useChangeCardStatus };
